/**
 * Shared location filtering configuration
 * These values should be consistent between client and server
 */

export const LOCATION_FILTERING_CONFIG = {
  // Accuracy thresholds (in meters)
  CLIENT_MAX_ACCURACY: 50,    // Client won't send points with worse accuracy
  SERVER_MAX_ACCURACY: 100,   // Server rejects points with worse accuracy (should be >= client)
  
  // Distance thresholds (in meters)
  CLIENT_MIN_DISTANCE: 5,     // Client won't send points closer than this
  SERVER_DUPLICATE_DISTANCE: 10, // Server considers points closer than this as duplicates (should be >= client)
  
  // Time thresholds (in milliseconds)
  CLIENT_MIN_TIME_DIFF: 2000,     // Client won't send points more frequently than this
  SERVER_DUPLICATE_TIME: 5000,    // Server considers points within this time as potential duplicates
  SERVER_RECENT_POINT_WINDOW: 10000, // Server checks for duplicates within this time window
} as const;

// Type for the config to ensure type safety
export type LocationFilteringConfig = typeof LOCATION_FILTERING_CONFIG;

/**
 * Validation: Ensure server thresholds are >= client thresholds
 * This prevents legitimate client behavior from being rejected by server
 */
const validateConfig = () => {
  if (LOCATION_FILTERING_CONFIG.SERVER_MAX_ACCURACY < LOCATION_FILTERING_CONFIG.CLIENT_MAX_ACCURACY) {
    console.warn('Server max accuracy should be >= client max accuracy');
  }
  
  if (LOCATION_FILTERING_CONFIG.SERVER_DUPLICATE_DISTANCE < LOCATION_FILTERING_CONFIG.CLIENT_MIN_DISTANCE) {
    console.warn('Server duplicate distance should be >= client min distance');
  }
  
  if (LOCATION_FILTERING_CONFIG.SERVER_DUPLICATE_TIME < LOCATION_FILTERING_CONFIG.CLIENT_MIN_TIME_DIFF) {
    console.warn('Server duplicate time should be >= client min time diff');
  }
};

// Run validation in development
if (process.env.NODE_ENV === 'development') {
  validateConfig();
}